/**
 * Public change-PIN API client.
 *
 * The raw token in the URL path is the sole credential — no login. Token
 * is single-used by the backend on a successful change.
 *
 * Backend mount: /api/vehicles/change-pin/:token (GET, POST).
 */

import axios from 'axios';

const BASE = `${(import.meta.env.VITE_API_URL || '').replace(/\/+$/, '')}/vehicles/change-pin`;

function url(token) {
  return `${BASE}/${encodeURIComponent(token)}`;
}

export async function loadChangePinContext(token) {
  const res = await axios.get(url(token));
  return res.data;
}

export async function changePin(token, { pin, confirmPin }) {
  const res = await axios.post(url(token), { pin, confirmPin });
  return res.data;
}
